import React, { useEffect } from "react";
import { useLocation, BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "./components/MainLayout";
import Landing from "./pages/homepage/Landing";
import WhatWeDo from "./pages/company/WhatWeDo";
import Workflow from "./pages/company/Workflow";
import History from "./pages/company/History";
import Equipment from "./pages/equipment/Equipment";
import Logistics from "./pages/services/Logistics";
import AirFreight from "./pages/services/Airfreight";
import OceanFreight from "./pages/services/OceanFreight";
import InterModal from "./pages/services/InterModal";
import ReeferExpress from "./pages/services/ReeferExpress";
import WareHouse from "./pages/services/WareHouse";
import CustomsClearance from "./pages/services/CustomsClearance";
import InternationalTrade from "./pages/services/InternationalTrade";
import HouseHold from "./pages/services/HouseHold";
import ProjectCargo from "./pages/services/ProjectCargo";
import Consolidated from "./pages/services/Consolidated";
import Contact from "./pages/contact/Contact";
import Login from "./pages/authentication/Login";
import Register from "./pages/authentication/Register";
import ForgotPassword from "./pages/authentication/ForgotPassword";
import ChangePassword from "./pages/authentication/ChangePassword";
import ViewProfile from "./pages/authentication/ViewProfile";
import EditProfile from "./pages/authentication/EditProfile";
import UserDashboard from "./pages/appUser/UserDashboard";
import AdminDashboard from "./pages/appAdmin/AdminDashboard";
import TrackShipment from "./pages/shipment/TrackShipment";
import NotFound from "./pages/generalPages/NotFound";
import CreateShipment from "./pages/appAdmin/CreateShipment";
import ShippingManifest from "./pages/appAdmin/ShippingManifest";
import ManageAppManagers from "./pages/appAdmin/ManageAppManagers";
import EditShipment from "./pages/appAdmin/EditShipment";

const ScrollToTop = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return null;
};
function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route path="/" element={<Landing />} />

          {/* COMPANY */}
          <Route path="/what-we-do" element={<WhatWeDo />} />
          <Route path="/workflow" element={<Workflow />} />
          <Route path="/history" element={<History />} />

          {/* EQUIPMENT */}
          <Route path="/equipment" element={<Equipment />} />

          {/* SERVICES */}
          <Route path="/services/logistics" element={<Logistics />} />
          <Route path="/services/airfreight" element={<AirFreight />} />
          <Route path="/services/ocean-freight" element={<OceanFreight />} />
          <Route path="/services/intermodal" element={<InterModal />} />
          <Route path="/services/reefer-express" element={<ReeferExpress />} />
          <Route
            path="/services/warehouse-distribution"
            element={<WareHouse />}
          />
          <Route
            path="/services/customs-clearance"
            element={<CustomsClearance />}
          />
          <Route
            path="/services/trade-compliance"
            element={<InternationalTrade />}
          />
          <Route path="/services/household-removals" element={<HouseHold />} />
          <Route path="/services/project-cargo" element={<ProjectCargo />} />
          <Route path="/services/consolidated-cargo" element={<Consolidated />} />

          {/* CONTACT */}
          <Route path="/contact" element={<Contact />} />

          {/* AUTHENTICATION */}
          <Route path="/application-user-login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/view-profile" element={<ViewProfile />} />
          <Route path="/edit-profile" element={<EditProfile />} />

          {/* APPLICATION USER*/}
          <Route path="/user-dashboard" element={<UserDashboard />} />

          {/* APPLICATION ADMIN*/}
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/admin/shipments/create" element={<CreateShipment />} />
          <Route path="/admin/shipments/manifest" element={<ShippingManifest />} />
          <Route path="/admin/managers" element={<ManageAppManagers />} />
          <Route path="/admin/shipments/:id/edit" element={<EditShipment />} />

          {/* GENERAL PAGES */}
          <Route path="/track-shipment" element={<TrackShipment />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
